"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var entries = function entries(obj) {
  for (var ownProps = Object.keys(obj), i = ownProps.length, resArray = Array(i); i--;) {
    resArray[i] = [ownProps[i], obj[ownProps[i]]];
  }

  return resArray;
};

exports.default = entries;